<template lang="pug">
.wagtail-quote(v-html="value")
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.wagtail-quote {
  width: 100%;
  padding: 55px 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  &::before {
    content: "";
    width: 220px;
    height: 4px;
    background-color: $primary;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -110px;
  }

  &::after {
    content: "";
    width: 220px;
    height: 4px;
    background-color: $primary;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -110px;
  }

  blockquote {
    text-align: center;
    font-size: 20px;
    color: $primary;
    text-transform: uppercase;
    font-weight: bold;
    max-width: 400px;
    margin: 0;
    font-family: 'Rubik';
  }
}
</style>